import { nanoid } from 'nanoid';
import { ClaudeMessage, Conversation } from '~api';

/**
 * @desc Creates a user message from text input
 */
export function createUserMessage(content: string): ClaudeMessage.User {
  return {
    role: 'user',
    content: [
      {
        type: 'text',
        text: content,
      },
    ],
  };
}

/**
 * @desc Creates a message event from a Claude message with proper metadata
 */
export function createMessageEvent(
  source: Conversation.EventSource,
  message: ClaudeMessage.All,
): Conversation.ClaudeMessageEvent {
  const now = new Date();
  // One id, used twice. The backend persists this prompt with `metadata.turnId = uid`, and
  // `uid` is this event's `id` (see ChatAgent.sendMessage and conversations.service.prompt),
  // so a second, independently-minted turnId here would only ever be wrong: the optimistic
  // turn would group under it, the persisted replacement under the event id, and the route's
  // `key={group.turnId}` would change on arrival — tearing the rendered turn down and
  // rebuilding it, rather than updating it, on every send.
  const id = nanoid();

  return {
    id,
    name: 'ClaudeMessage',
    source,
    payload: message,
    timestamp: now,
    metadata: {
      turnId: id,
      turn: {
        tStart: now.toISOString(),
      },
    },
  };
}
